export var VehicleType;
(function (VehicleType) {
    VehicleType[VehicleType["Car"] = 1] = "Car";
    VehicleType[VehicleType["Truck"] = 2] = "Truck";
    VehicleType[VehicleType["SUV"] = 3] = "SUV";
    VehicleType[VehicleType["Van"] = 4] = "Van";
    VehicleType[VehicleType["Other"] = 5] = "Other";
    VehicleType[VehicleType["Motorcycle"] = 6] = "Motorcycle";
    VehicleType[VehicleType["ATV_UTV"] = 7] = "ATV_UTV";
    VehicleType[VehicleType["Coupe"] = 8] = "Coupe";
    VehicleType[VehicleType["EV"] = 9] = "EV";
})(VehicleType || (VehicleType = {}));
export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus[QuoteStatus["None"] = 1] = "None";
    QuoteStatus[QuoteStatus["Pending"] = 2] = "Pending";
    QuoteStatus[QuoteStatus["Completed"] = 3] = "Completed";
    QuoteStatus[QuoteStatus["Expired"] = 4] = "Expired";
})(QuoteStatus || (QuoteStatus = {}));
export var Drivability;
(function (Drivability) {
    Drivability[Drivability["RideAndDrive"] = 1] = "RideAndDrive";
    Drivability[Drivability["Inoperational"] = 2] = "Inoperational";
})(Drivability || (Drivability = {}));
export var GatePassType;
(function (GatePassType) {
    GatePassType[GatePassType["NotRequired"] = 1] = "NotRequired";
    GatePassType[GatePassType["Pending"] = 2] = "Pending";
    GatePassType[GatePassType["Attached"] = 3] = "Attached";
})(GatePassType || (GatePassType = {}));
